import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import 'vuetify/styles'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import { vMaska } from 'maska'

import './assets/styles/main.css'
import './assets/styles/data-table.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vuetify)
app.use(i18n)
app.directive('maska', vMaska)
app.mount('#app') 